module.exports = __webpack_public_path__ + "img/bankomat.0fd19ed7.svg";